import React from 'react';
import Dialog from '@mui/material/Dialog';
import Icon from 'screens/shared/icon';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default ({
  show = false,
  onClose = null,
  content = '',
  actions = '',
  title = '',
  titleClassName = '',
  isCloseButton = false,
  closeHandler = () => {},
  style = {},
}) => (
  <Dialog
    open={show}
    onClose={onClose}
    aria-labelledby="responsive-dialog-title"
    className="dialog"
  >
    <DialogTitle id="responsive-dialog-title" className={titleClassName}>{title}</DialogTitle>
    <DialogContent style={style}>
      {content}
      {isCloseButton && (
        <span className="dialog-close-button" onClick={closeHandler}>
          <Icon name="times" />
        </span>
      )}
    </DialogContent>
    {actions && (
      <DialogActions>
        {actions}
      </DialogActions>
    )}
  </Dialog>
);
